import React from 'react'
import ChargebackDisputeController from '../controllers/ChargebackDisputeController'
import { TChargebackDispute } from '../types/ChargebackDispute'
import { IErrorResponse } from '../types/ErrorResponse'

// Busca pelo id da disputa ou pelo orderChargeId da transação
export const useChargebackDispute = ({
  id,
  orderChargeId,
}: {
  id?: string
  orderChargeId?: string
}) => {
  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState<TChargebackDispute | null>(null)
  const [error, setError] = React.useState('')
  const [notFound, setNotFound] = React.useState(false)

  const execute = async () => {
    if (!id && !orderChargeId) return
    setLoading(true)
    setError('')
    setNotFound(false)
    try {
      const response = id
        ? await ChargebackDisputeController.get({ id })
        : await ChargebackDisputeController.getByCharge({
            orderChargeId: orderChargeId!,
          })
      const responseError = response as IErrorResponse
      if (responseError.code) {
        setData(null)
        if (responseError.code === 404) {
          setNotFound(true)
        } else {
          setError(responseError.error)
        }
      } else {
        setData(response as TChargebackDispute)
      }
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    execute()
  }, [id, orderChargeId])

  const clear = () => setError('')

  return { loading, data, error, notFound, execute, clear }
}
